import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/lib/content";

const fade = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true, margin: "-80px" },
};

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="border-t border-hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-28 lg:py-40">
        <motion.div {...fade} className="max-w-3xl">
          <span className="overline" data-testid="testimonials-overline">Mentees</span>
          <h2 className="font-serif text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight mt-6">
            What the work
            <br />
            <span className="italic font-light text-platinum">sounds like, after.</span>
          </h2>
        </motion.div>

        <div className="mt-24 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`testimonial-${i}`}
              className="border-t border-hairline pt-10"
            >
              <div
                aria-hidden
                className="font-serif text-5xl text-platinum/40 leading-none"
              >
                “
              </div>
              <blockquote className="mt-4 font-serif text-xl md:text-2xl leading-snug text-bone">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 overline">
                {t.name} — <span className="text-smoke normal-case tracking-normal">{t.detail}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
